import { FC } from "react"
import { AirkitIcon } from "../../icons/AirkitIcon"
import { BubbleIcon } from "../../icons/BubbleIcon"
import { HtmlIcon } from "../../icons/HtmlIcon"
import { InnoveoIcon } from "../../icons/InnoveoIcon"
import { JsIcon } from "../../icons/JsIcon"
import { ReactIcon } from "../../icons/ReactIcon"
import { VueIcon } from "../../icons/VueIcon"

export const IntegrateSection: FC = () => {
  return (
    <div className="flex lg:flex-row flex-col gap-x-6">
      <div>
        <h6 className="uppercase text-[10px] text-brand-greyish font-bold mt-3 mb-2">Low code, no code</h6>
        <div className="flex gap-x-2">
          <BubbleIcon />
          <AirkitIcon />
          <InnoveoIcon />
        </div>
      </div>
      <div>
        <h6 className="uppercase text-[10px] text-brand-greyish font-bold mt-3 mb-2">Custom programming</h6>
        <div className="flex gap-x-2">
          <ReactIcon />
          <VueIcon />
          <HtmlIcon />
          <JsIcon />
        </div>
      </div>
    </div>
  )
}

